import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { IItemLookup } from 'src/common/interfaces/dtos/IItemLookup';
import { IBottleReturnState } from 'src/common/interfaces/states/IBottleReturnState';

const initialState: IBottleReturnState = { itemList: [] };

class BottleReturnResponseReducer extends ImmerReducer<IBottleReturnState> {
  public setBottleReturnItemState(itemList: IItemLookup[]): void {
    this.draftState = { itemList };
  }

  public setBottleReturnSelectedItemState(selectedItem: IItemLookup): void {
    this.draftState = { ...this.draftState, selectedItem };
  }

  public resetState() {
    this.draftState = initialState;
  }
}

export const BottleReturnActions = createActionCreators(BottleReturnResponseReducer);
export const BottleReturnReducerFunction = createReducerFunction(
  BottleReturnResponseReducer,
  initialState,
);
